<template>
    <div class="wrapper bg-template pagethankyou">
        <b-row no-gutters class="login-row">
            <b-container class="align-self-center">
                <b-row>
                    <b-col cols="12" class="text-center">
                        <b-img :src="img" alt="img-felicitaciones" class="mw-100"/>
                        <h2 class="mt-5">Felicitaciones</h2>
                        <p class="text-mute mt-3">¡Ahora tienes tu cuenta con nosotros<br>puedes empezar a realizar tus envíos!</p>
                    </b-col>
                </b-row>
            </b-container>
        </b-row>

        <!-- bottom buttons -->
        <b-row class="mx-0 bottom-button-container">
            <b-col class="text-center">
                <div class="laoderhorizontal">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </b-col>
        </b-row>
        <!-- bottom buttons ends -->
    </div>
</template>

<script>
export default {
    name: "Welcome",
    data: () => ({
        img: '/img/info-congratulation.png'
    }),
    mounted() {
        this.loginRow();
        window.addEventListener("resize", this.loginRow);
        this.timeout = setTimeout(this.endWelcome, 5000);
        this.$emit('loader');
        this.$root.$bvToast.toast('¡Bienvenido a MoreGiros!', {
            title: 'Felicitaciones',
            headerClass: 'd-none',
            variant: 'success',
            toaster: 'b-toaster-top-right',
            autoHideDelay: 5000,
            solid: true,
            appendToast: true
        });
    },
    methods: {
        loginRow() {
            $('.login-row').css('min-height', ($(window).height() - 80));
        },
        endWelcome() {
            this.$router.push({ name: 'Home' });
        }
    },
    destroyed() {
        clearTimeout(this.timeout);
    }
}
</script>

<style scoped>

</style>
